export class Progress {
  /**
   *
   * @param {HTMLElement} place
   */
  constructor(place, classList = '') {
    this.place = place
    this._loadingState = 0
    this.element = document.createElement('div')
    this.element.classList.add('progress', ...classList.split(' '))
  }
  set loadingState(state) {
    if (state > 0) {
      if (!Array.from(this.place.childNodes).includes(this.element)) {
        this.place.appendChild(this.element)
      }
    } else {
      this.element.remove()
    }
    this._loadingState = state
  }
  get loadingState() {
    return this._loadingState
  }
  run() {
    this.loadingState += 1
    return () => {
      this.loadingState -= 1
    }
  }
}
